import { createLogger } from '@owl-lib/logger';
import { deserialize, fetchWrapper } from '../fetch';
import { UserEvent } from './interface';
const logger = createLogger(__filename);
const userEventApiClient = {
  addUserEvent: async (userEvent: UserEvent): Promise<number> => {
    const url = new URL('/app/v1/user_events', API_BASE_URL);
    logger.trace('userEventApiClient.addUserEvent()');
    return deserialize(
      await fetchWrapper(url.href, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userEvent),
      })
    );
  },
};
export default userEventApiClient;
